module.exports = ".ks-health-com-image{width:24.154589372vw;height:24.154589372vw}"